














































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { ROUTE_ALPACAS, ROUTE_ADOPT } from '@/router';
import { EventBus } from '@/utils/EventBus';
import { getStakingFees } from '@/backend/requests';
import { alpaUnit } from '@/utils/unit';
import BigNumber from 'bignumber.js';
import {
  validateAccount,
  allowance,
  increaseAllowance,
  balanceOf,
  enter,
  leave,
  xalpaBalanceOf,
  alpaRewardContractAddress,
  totalStaked,
  totalSupply,
} from '@/utils/web3';

@Component({
  components: {
    AlpacaCard,
    AlpacaBtn,
  },
})
export default class Stake extends Vue {
  public stakeIn: string = '0';
  public stakeOut: string = '0';
  public allowanceAmount: number = -1;
  public balanceOfAlpa: BigNumber = new BigNumber(0);
  public balanceOfXALPA: BigNumber = new BigNumber(0);
  public approveLoading: boolean = false;
  public stakingFees: BigNumber = new BigNumber(0);
  public totalStaked: BigNumber = new BigNumber(0);
  public userDeposit: BigNumber = new BigNumber(0);
  public totalSupply: BigNumber = new BigNumber(1);

  get ROUTE_ALPACAS() {
    return ROUTE_ALPACAS;
  }

  get ROUTE_ADOPT() {
    return ROUTE_ADOPT;
  }

  get account() {
    return this.$store.getters.getAccount;
  }

  get showApprove() {
    if (this.allowanceAmount >= Number(this.stakeIn)) {
      return false;
    }
    return true;
  }

  get apy() {
    if (this.stakingFees && this.totalStaked) {
      return this.stakingFees.dividedBy(this.totalStaked).multipliedBy(365 * 100);
    }
    return 0;
  }

  get equalAlpa() {
    return this.balanceOfXALPA.multipliedBy(this.totalStaked).dividedBy(this.totalSupply);
  }

  get userEarnings() {
    return this.equalAlpa.minus(this.userDeposit);
  }

  public mounted() {
    EventBus.$on('approve-status', this.onApproveStatus);
  }

  public beforeDestroy() {
    EventBus.$off('approve-status', this.onApproveStatus);
  }

  public async getStakingFees() {
    const res = await getStakingFees();
    if (res) {
      this.stakingFees = alpaUnit(res.data);
    }
  }

  // public async getUserStake() {
  //   const res = await getUserStake(this.account);
  //   if (res) {
  //     this.userDeposit = alpaUnit(res.data.stakes);
  //   }
  // }

  public async getTotalStaked() {
    const amount = await totalStaked();
    if (amount) {
      this.totalStaked = new BigNumber(amount);
    }
  }

   public async getTotalSupply() {
    const amount = await totalSupply();
    if (amount) {
      this.totalSupply = new BigNumber(amount);
    }
  }

  public routeTo(name: string) {
    this.$router.push({name});
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public async getCurAllowance() {
    this.allowanceAmount = Number(await allowance(this.account, alpaRewardContractAddress!));
  }

  public async getBalanceOfAlpa() {
    this.balanceOfAlpa = new BigNumber(await balanceOf(this.account));
  }

  public async getBalanceOfXALPA() {
    this.balanceOfXALPA = new BigNumber(await xalpaBalanceOf(this.account));
  }

  public async handleApprove() {
    if (!this.account) {
      return;
    }
    this.approveLoading = true;
    increaseAllowance(this.account, alpaRewardContractAddress!, 10000000);
  }

  public async onApproveStatus(status: 'approving' | 'completed' | 'error') {
    if (status === 'completed') {
      await this.getCurAllowance();
      this.approveLoading = false;
    }
    if (status === 'error') {
      this.approveLoading = false;
    }
  }

  public maxStake(option: 'in' | 'out') {
    if (option === 'in') {
      this.stakeIn = this.balanceOfAlpa.toString();
    } else {
      this.stakeOut = this.balanceOfXALPA.toString();
    }
  }

  public handleStakeIn() {
    EventBus.$emit('trx-result', {status: 'loading', trxId: ''});
    enter(this.account, new BigNumber(this.stakeIn));
  }

  public handleStakeOut() {
    EventBus.$emit('trx-result', {status: 'loading', trxId: ''});
    leave(this.account, new BigNumber(this.stakeOut));
  }

  public stakeInChange() {
    if (this.stakeIn === '') {
      return;
    } else if (new BigNumber(this.stakeIn).isLessThan(0)) {
      this.stakeIn = '0';
    } else if (new BigNumber(this.stakeIn).isGreaterThan(this.balanceOfAlpa)) {
      this.stakeIn = this.balanceOfAlpa.toString();
    }
  }

  public stakeOutChange() {
    if (this.stakeOut === '') {
      return;
    } else if (new BigNumber(this.stakeOut).isLessThan(0)) {
      this.stakeOut = '0';
    } else if (new BigNumber(this.stakeOut).isGreaterThan(this.balanceOfXALPA)) {
      this.stakeOut = this.balanceOfXALPA.toString();
    }
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getCurAllowance();
      this.getBalanceOfAlpa();
      this.getBalanceOfXALPA();
      this.getStakingFees();
      this.getTotalStaked();
      // this.getUserStake();
      this.getTotalSupply();
    }
  }
}
